import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SocieteModel } from '../models/simple-types/societe.model';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private societySource = new BehaviorSubject<SocieteModel>(null);
  society = this.societySource.asObservable();
  private userSource = new BehaviorSubject<string>("christelle.gosset@veolia.com");
  user = this.userSource.asObservable();

  changeSociety(society: SocieteModel): void {
    this.societySource.next(society);
  }
}
